<div class="dialog-container">
  <h2 mat-dialog-title class="dialog-title">Crear nuevo tipo de documento</h2>

  <div mat-dialog-content>
    <form [formGroup]="form" class="form-content">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Nombre</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Slug</mat-label>
        <input matInput formControlName="slug" readonly />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-100">
        <mat-label>Tipo relacionado</mat-label>
        <mat-select formControlName="related_type">
          @for (option of morphOptions; track option.value) {
            <mat-option [value]="option.value">
              {{ option.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="checkbox-container">
        <mat-checkbox formControlName="related_user_can_view_document">
          El usuario relacionado puede ver el documento
          <mat-icon
            class="info-icon"
            matTooltip="Si se marca este campo, el usuario relacionado al documento podrá ver y descargar documentos de este tipo. Si no se marca, solo los administradores y RRHH podrán acceder a estos documentos."
            matTooltipPosition="above"
          >
            info
          </mat-icon>
        </mat-checkbox>
      </div>
    </form>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-stroked-button (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="accent" [disabled]="form.invalid" (click)="save()" type="submit">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</div>
